import React from 'react';

function WrapOverText(props) {
  var wrapOver = props.wrapOver;
  if (wrapOver === undefined) wrapOver = 30;

  const value = props.value;

  if (value.length > wrapOver) {
    return value;
  }
  else {
    return <span style={{ whiteSpace: 'nowrap' }}>{value}</span>;
  }
}

export default WrapOverText;
